export default __webpack_public_path__ + "static/media/tfacontract.88ab8600.pdf";